import { HttpError } from "@refinedev/core";
import { useTable } from "@refinedev/react-table";

import { DataTable } from "@/components/refine-ui/data-table/data-table";
import { DataTableActionBar } from "@/components/refine-ui/data-table/data-table-action-bar";
import { ListView } from "@/components/refine-ui/views/list-view";
import { useTeamColumns } from "@/pages/teams/hooks/use-columns";
import { ITeamData } from "@/types/team";

export const TeamsList = () => {
  const columns = useTeamColumns();

  const table = useTable<ITeamData, HttpError>({
    columns,
    enableColumnResizing: true,
    columnResizeMode: "onChange",
    initialState: {
      columnVisibility: { id: false },
      columnPinning: { right: ["actions"] },
    },
    refineCoreProps: {
      // Teams have no sortable string field, so no initial sorter.
      meta: { defaultQueryBy: "name,shortName,city" },
      pagination: { pageSize: 25 },
    },
  });

  return (
    <ListView>
      <DataTableActionBar resource="teams" table={table} />
      <DataTable table={table} />
    </ListView>
  );
};
